import React, {
    createContext,
    useReducer,
    PropsWithChildren,
    Dispatch,
} from "react";

import { convertDatesInPlace } from "../services/util";

import { IntegrationsPayload } from "./Integrations";

export enum ActionType {
    LOGIN = "login",
    UPDATE_USER = "update",
    LOGOUT = "logout",
}

export interface User {
    id: string;
    apiKey: string;
    profilePicture?: string;
}

export interface LoginPayload {
    user: User;
    token: string;
    integrations: IntegrationsPayload;
}
export interface GoogleOAuthPayload {
    url: string;
}

interface LoginAction {
    type: ActionType.LOGIN;
    payload: LoginPayload;
}

interface UpdateUserAction {
    type: ActionType.UPDATE_USER;
    user: User;
}

interface LogoutAction {
    type: ActionType.LOGOUT;
}

type Action = LoginAction | UpdateUserAction | LogoutAction;

export interface State {
    user?: User;
    token?: string;
}

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case ActionType.LOGIN:
            localStorage.setItem("user", JSON.stringify(action.payload.user));
            localStorage.setItem("token", action.payload.token);

            return {
                ...state,
                ...action.payload,
            };

        case ActionType.UPDATE_USER:
            localStorage.setItem(
                "user",
                JSON.stringify({
                    ...state.user,
                    ...action.user,
                }),
            );

            return {
                ...state,
                user: action.user,
            };

        case ActionType.LOGOUT:
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            return {};

        default:
            return state;
    }
};

export const Context = createContext<{
    state: State;
    dispatch: Dispatch<Action>;
}>({
    state: {},
    dispatch: () => {},
});

export const Store = ({ children }: PropsWithChildren<{}>) => {
    const existingUser: User = JSON.parse(
        localStorage.getItem("user") || "null",
    );
    const existingToken = localStorage.getItem("token");

    const [state, dispatch] = useReducer(reducer, {
        user: existingUser ?? undefined,
        token: existingToken ?? undefined,
    });

    return (
        <Context.Provider value={{ state, dispatch }}>
            {children}
        </Context.Provider>
    );
};
